export { WelcomeDialogsComponent } from './welcome-dialogs.component';
export { WelcomeDialogsService } from './services';
